import { render, staticRenderFns } from "./BookingReturnTable.vue?vue&type=template&id=59415ce8&scoped=true"
import script from "./BookingReturnTable.vue?vue&type=script&lang=js"
export * from "./BookingReturnTable.vue?vue&type=script&lang=js"
import style0 from "./BookingReturnTable.vue?vue&type=style&index=0&id=59415ce8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59415ce8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59415ce8')) {
      api.createRecord('59415ce8', component.options)
    } else {
      api.reload('59415ce8', component.options)
    }
    module.hot.accept("./BookingReturnTable.vue?vue&type=template&id=59415ce8&scoped=true", function () {
      api.rerender('59415ce8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods_activity/booking/BookingReturnTable.vue"
export default component.exports